import React, { Fragment, useState } from 'react';
import { Polygon } from 'react-leaflet';
import { flatten, chain } from 'lodash';
import { areaHighLightColor } from '../../constants/colors';

export default function RenderOLSObstacleFreeZone({
  OLSObstacleFreeZoneList,
  selectedOls,
  getOLSColors
}) {
  const [selectedOverE, setSelectedOverE] = useState(null);
  const olsColor = getOLSColors();
  const visibleOLSObstacleFreeZoneList =
    chain(OLSObstacleFreeZoneList)
      .filter((ofzObj) => {
        const name = `OFZ_${ofzObj.type}_${ofzObj.rwy_designator}`;
        return selectedOls.includes(`${name}__${olsColor[name]}`);
      })
      .value();

  const handlePolygonOver = (e, element) => {
    e.target.bringToFront();
    setSelectedOverE(element);
  };

  const handlePolygonOut = () => {
    setSelectedOverE(null);
  };

  return (
   <Fragment>
     {
        visibleOLSObstacleFreeZoneList.map((olsOfz) => {
          const ofzCoordinates = olsOfz.coordinates.coordinates;
          const ofzCoordinateMap = flatten(ofzCoordinates).map((ofzCoords) => {
            return ofzCoords.map((ofz) => {
              return {
                lng: ofz[0],
                lat: ofz[1]
              };
            });
          });

          return ofzCoordinateMap.map((ofzPolygonPath, i) => (
            <Polygon
              key={i}
              pane="tilePane"
              positions={ofzPolygonPath}
              pathOptions={{
                fillColor: olsColor[olsOfz.type],
                color: selectedOverE?.type === olsOfz.type ? areaHighLightColor : olsColor[olsOfz.type],
                weight: selectedOverE?.type === olsOfz.type ? 3 : 2,
              }}
              eventHandlers={{
                mouseover: (e) => handlePolygonOver(e, olsOfz),
                mouseout: () => handlePolygonOut()
              }}
            />
          ));
        })
     }
   </Fragment> 
  )
}